// =============================================================================
// Em-dash cleanup — TYLKO myslniki interpunkcyjne, NIGDY zakresy liczbowe.
//
// ROOT CAUSE defektu "8, 12 godzin" (wykryty 2026-08-24, obecny od miesiecy):
// stary post-processing w humanizationService robil
//   finalHtml.replace(/\s*[—–]\s*/g, ", ")   dla pierwszych N "nadmiarowych"
// — klasa [—–] lapala tez POLPAUZE W ZAKRESACH LICZB ("8–12", "200–450 zl"),
// a \s* dopasowuje pusto, wiec "8–12" -> "8, 12". Poniewaz podmieniane byly
// wystapienia od poczatku dokumentu, poczatek artykulu mial glitch, a koniec
// zdrowe zakresy (excess sie wyczerpywal) — stad "losowosc".
//
// Zasada: myslnik/polpauza MIEDZY CYFRAMI (takze przez spacje: "20 000 – 45 000")
// to zakres i jest NIETYKALNY. Limit dotyczy wylacznie interpunkcji zdaniowej.
// =============================================================================

export interface EmDashCleanupResult {
  html: string;
  /** wszystkie [—–] w dokumencie */
  total: number;
  /** ile z nich to interpunkcja zdaniowa (podlega limitowi) */
  punctuational: number;
  /** ile zamieniono na ", " */
  converted: number;
  limit: number;
}

/** Czy myslnik na pozycji `i` stoi miedzy cyframi (zakres liczbowy)? */
function isRangeDashAt(s: string, i: number): boolean {
  let l = i - 1;
  while (l >= 0 && s[l] === " ") l--;
  let r = i + 1;
  while (r < s.length && s[r] === " ") r++;
  return l >= 0 && r < s.length && /\d/.test(s[l]) && /\d/.test(s[r]);
}

export function cleanupEmDashes(html: string): EmDashCleanupResult {
  const wordCount = html.replace(/<[^>]+>/g, " ").split(/\s+/).filter(Boolean).length;
  const limit = Math.max(4, Math.ceil(wordCount / 1000) * 4);

  let total = 0;
  let punctuational = 0;
  for (let i = 0; i < html.length; i++) {
    const ch = html[i];
    if (ch === "—" || ch === "–") {
      total++;
      if (!isRangeDashAt(html, i)) punctuational++;
    }
  }

  if (punctuational <= limit) {
    return { html, total, punctuational, converted: 0, limit };
  }

  let excess = punctuational - limit;
  let converted = 0;
  const out = html.replace(/\s*[—–]\s*/g, (match, offset: number) => {
    const dashIdx = offset + match.search(/[—–]/);
    if (isRangeDashAt(html, dashIdx)) return match; // zakres — nietykalny
    if (excess > 0) {
      excess--;
      converted++;
      return ", ";
    }
    return match;
  });

  return { html: out, total, punctuational, converted, limit };
}
